"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M42.357 5.643a11.071 11.071 0 0 0-15.657 0c-.594.594-3.806 3.741-5.483 5.418a12.818 12.818 0 0 1 5.774.939c.8-.8 2.732-2.668 3.064-3A6.327 6.327 0 0 1 39 17.945l-8.2 8.2c-2.47 2.47-6.9 2.76-9.375.289a6.419 6.419 0 0 1-1.915-2.508 3.125 3.125 0 0 0-.659.49l-2.524 2.641a11.006 11.006 0 0 0 1.892 2.581c4.324 4.324 12.149 3.648 16.472-.676l7.666-7.662a11.071 11.071 0 0 0 0-15.657z" }),
  React.createElement("path", { d: "M20.8 36.072c-.8.8-2.524 2.6-2.855 2.93A6.327 6.327 0 0 1 9 30.055l8.214-8.214c2.471-2.471 6.854-2.75 9.325-.279a6.079 6.079 0 0 1 1.706 2.577 3.125 3.125 0 0 0 .659-.491l2.676-2.655a11.006 11.006 0 0 0-1.892-2.581 11.28 11.28 0 0 0-15.829.073L5.643 26.7A11.071 11.071 0 0 0 21.3 42.357c.594-.594 3.6-3.672 5.274-5.349a12.818 12.818 0 0 1-5.774-.936z" })
);

